// src/components/MapComponent.js

import React, { useEffect, useRef, useState } from 'react';
import CorporateImage from '../../Images/new_corporate.png'
import ApartmentImage from '../../Images/new_apartment.png'
import MallImage from '../../Images/new_mall.png'
import Seller from '../../Images/seller.png'
import Marker from '../../Images/marker.png'
import MapCenter from '../../Images/map_center.png'
import UsedCarImage from '../../Images/ucd_logo.png'
// Your Google Maps API key
const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY; // Ensure to add your API key in .env file

// Function to dynamically load the Google Maps script
const loadGoogleMaps = (apiKey) => {
    return new Promise((resolve, reject) => {
      // Check if Google Maps is already loaded
      if (window.google && window.google.maps) {
        resolve(window.google);
        return;
      }
  
      // Create script element to load Google Maps
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
  
      // Resolve the promise when the script is loaded
      script.onload = () => resolve(window.google);
  
      // Reject the promise if there's an error loading the script
      script.onerror = () => reject(new Error('Failed to load Google Maps script'));
  
      // Append the script element to the document head
      document.head.appendChild(script);
    });
  };

  
  // React component to display the map
  const MapComponent = ({ locations, latitude, longitude }) => {
    const mapRef = useRef(null);
    const [map, setMap] = useState(null);
    const [infoWindow, setInfoWindow] = useState(null);
    const icons = {
        Corporate: CorporateImage,
        Society: ApartmentImage,
        Mall: MallImage,
        ncd:Seller,
        current:Marker,
        ucd: UsedCarImage,   
      };
    
      locations.push({
        client_name: "Your Current Location",
        lat: latitude,
        lng: longitude,
        project_type:'current'});

    useEffect(() => {
      loadGoogleMaps(apiKey)
        .then((google) => {
          // Create a new map centered on the first location or default coordinates
          const mapInstance = new google.maps.Map(mapRef.current, {
            center: { lat: latitude, lng: longitude },
            zoom: 15,
          });
          setMap(mapInstance);
  
          // Create InfoWindow instance
          const infoWindowInstance = new google.maps.InfoWindow({
            maxWidth: 350,
            pixelOffset: new google.maps.Size(-10, -25),
          });
          setInfoWindow(infoWindowInstance);
        })
        .catch((error) => {
          console.error('Error loading Google Maps:', error);
        });
    }, [locations]);
  
    useEffect(() => {
      if (map && locations.length > 0) {
        // Clear existing markers
        if (map.markers) {
          map.markers.forEach(marker => marker.setMap(null));
          map.markers = [];
        } else {
          map.markers = [];
        }
  
        // Add a marker for each location
        locations.forEach((location, index) => {
        const iconPath = icons[location.project_type];
          const marker = new window.google.maps.Marker({
            position: { lat: location.lat, lng: location.lng },
            map: map,
            title: `${location.client_name} - ${location.project_type}`,
            icon: {
              url: iconPath,
              scaledSize: new window.google.maps.Size(
                location.project_type?.toUpperCase() === "UCD" ? 55 : 32,
                location.project_type?.toUpperCase() === "UCD" ? 55 : 32
              )
            }
          });
        
          marker.addListener('click', () => {
            if(location.project_type=='current'){
              var content = `
              <div style="font-family: Arial, sans-serif; color: #333;">
                  <h3 style="margin: 0 0 10px; padding: 0; font-weight: bold; font-size: 20px;">${location.client_name}</h3>
                  <p style="margin: 5px 0; font-size: 14px;"><strong>Latitude:</strong> ${location.lat}</p>
                  <p style="margin: 5px 0; font-size: 14px;"><strong>Longitude:</strong> ${location.lng}</p>
                  `;
            }else{
            var content = `
                        <div style="font-family: Arial, sans-serif; color: #333;">
                            <h3 style="margin: 0 0 10px; padding: 0; font-weight: bold; font-size: 20px;">${location.client_name}</h3>
                            <p style="margin: 5px 0; font-size: 14px;"><strong>Project Type:</strong> ${location.project_type}</p>
                            
                    `;
            }
              if(location.live_date != null){
                var content = content+` <p style="margin: 5px 0; font-size: 14px;"><strong>Member since:</strong> ${location.live_date}</p>`;
              }

              if(location.newRate > 0){
                var content = content+` <p style="margin: 5px 0; font-size: 14px;"><strong>Rating:</strong> ${location.newRate}</p>`;
              }

              var content = content+` </div>`;
            
            infoWindow.setContent(content);
            infoWindow.setPosition(window.google.maps.LatLng(location.lat, location.lng));
            infoWindow.open(map, marker);
          });
  
          map.markers.push(marker);
        });
      }
    }, [map, locations, infoWindow]);

    const handleReCenter = () => {
      map.setCenter({
        lat : latitude,
        lng : longitude
      });
    }
  
    return (
      <>
        <div>
          <div style={{position: 'absolute', right: '62px', zIndex: '999'}}>
            <button onClick={handleReCenter} title="Click to recenter the map" type="button" style={{backgroundColor: 'rgb(255, 255, 255)', border: '2px solid rgb(255, 255, 255)', borderRadius: '3px', boxShadow: 'rgba(0, 0, 0, 0.3) 0px 2px 6px', color: 'rgb(25, 25, 25)', cursor: 'pointer', fontFamily: 'Roboto, Arial, sans-serif', fontSize: '16px', lineHeight: '38px', margin: '8px 0px 22px', padding: '0px 5px', textAlign: 'center'}}><img src={MapCenter} style={{height: '20px'}}/></button>
          </div>
        </div>
        <div
          ref={mapRef}
          style={{
            height: '500px',
            width: '100%',
          }}
        />
      </>
    );
  };
  
  export default MapComponent;